/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Colleagues_EmptyInputs */



/**
* | output |
* | --- |
* | "We haven't found any one-to-ones in your calendar yet. Wundo recognises them as soon as they are in it." |
*
* @param {Onboarding_Colleagues_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_colleagues_empty = /** @type {((inputs?: Onboarding_Colleagues_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Colleagues_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We vonden nog geen one-to-ones in je agenda. Wundo herkent ze vanzelf zodra ze erin staan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas encore trouvé de one-to-ones dans votre agenda. Wundo les reconnaît dès qu'ils y figurent.")
	return /** @type {LocalizedString} */ ("We haven't found any one-to-ones in your calendar yet. Wundo recognises them as soon as they are in it.")
});